import { ItemID } from "types/common";
import { TaxonomyItem } from "types/entities/Taxonomy";

import { QueryClient } from "@tanstack/react-query";

import { QueryKeys } from "api/queryKeys";

export const chunkIds = (ids: ItemID[], size: number): ItemID[][] => {
  const chunks: ItemID[][] = [];
  for (let start = 0; start < ids.length; start += size) chunks.push(ids.slice(start, start + size));
  return chunks;
};

export const splitCachedIds = (ids: ItemID[], lookup: (id: ItemID) => TaxonomyItem | undefined) => {
  const cachedItems: TaxonomyItem[] = [];
  const missingIds: ItemID[] = [];
  ids.forEach((id) => {
    const item = lookup(id);
    if (item) cachedItems.push(item);
    else missingIds.push(id);
  });
  return { cachedItems, missingIds };
};

// Each item a bulk lookup returns is cached on its own, so later lookups skip it
export const cacheTaxonomyItems = (queryClient: QueryClient, items: TaxonomyItem[]) => {
  items.forEach((item) => queryClient.setQueryData([QueryKeys.GET_TAXONOMY_ITEM_BY_ID, item.id], item));
};

export const getCachedTaxonomyItem = (queryClient: QueryClient, id: ItemID): TaxonomyItem | undefined => {
  const fromBulkLookup = queryClient.getQueryData<TaxonomyItem>([QueryKeys.GET_TAXONOMY_ITEM_BY_ID, id]);
  if (fromBulkLookup) return fromBulkLookup;

  // The table's Matching Result cells cache each product they show, keyed by id plus their expand list
  return queryClient
    .getQueriesData<TaxonomyItem>({ queryKey: [QueryKeys.GET_TAXONOMY_ITEM, id] })
    .map(([, item]) => item)
    .find((item): item is TaxonomyItem => Boolean(item));
};
